import React from 'react';
import { Rate } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';
import { ReviewEntry } from '@benzinga/content-manager';

export interface ReviewEntryCardProps {
  entry: ReviewEntry;
}

export const ReviewEntryCard: React.FC<ReviewEntryCardProps> = ({ entry }) => {
  return (
    <ReviewEntryWrapper className="review-entry bg-gray-50 p-2 border rounded px-2">
      <div className="review-entry-top">
        <h3 className="leading-6 font-manrope text-left text-base text-blue-nocollight_30 m-0 font-bold uppercase">
          {entry.name}
        </h3>
        <Rate readOnly={true} value={entry.entries.rating_1?.value} />
      </div>
      {entry.comment && <p className="comment text-sm mt-2">{entry.comment}</p>}
      {Object.keys(entry.entries).map((entry_key, i) => {
        const e = entry.entries[entry_key];
        if (entry_key.match('custom_field')) {
          if (!e.value) return null;
          return (
            <div className="custom-e mt-1" key={`review-${i}`}>
              <div className="label relative bg-gray-50 text-blue-light_30 text-sm font-bold inline-block uppercase mb-2">
                <span className="">{e.label}</span>
              </div>
              <EntryValue className="review-data">
                <p className="text-blue-dark_60 text-sm font-medium">{e.value}</p>
              </EntryValue>
            </div>
          );
        }
        return null;
      })}
    </ReviewEntryWrapper>
  );
};

const ReviewEntryWrapper = styled.div`
  border-color: ${({ theme }) => theme.colorPalette.gray200};
  background-color: #fafcff;
  .label {
    background-color: #fafcff;
  }
`;

const EntryValue = styled.div`
  border-color: ${({ theme }) => theme.colorPalette.gray200};
`;
